import $$ from 'cmn-utils'

const baseUrl = "/api/sys/permission/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    resourcePermissionList: (params) => {
        return $$.get(baseUrl + 'resource-permission-list', params)
    },
    roleResourcePermissionList: (params) => {
        return $$.get(baseUrl + 'role-resource-permission-list', params)
    },
    roleResourcePermissionListUpdate: (params) => {
        return $$.get(baseUrl + 'role-resource-permission-list-update', params)
    },

}